import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
const faqs = [{
  q: '¿El plan es caro?',
  a: 'No, está basado en ingredientes de feria y supermercado local.'
}, {
  q: '¿Tengo que dejar de comer asados?',
  a: 'No, te enseñamos a elegir para que disfrutes sin inflamarte.'
}, {
  q: '¿Cuánto tiempo me tomará ver resultados?',
  a: 'La mayoría de las mujeres reportan menos hinchazón en las primeras 48 a 72 horas.'
}, {
  q: '¿Sirve para la menopausia?',
  a: 'Absolutamente, está diseñado para el cambio hormonal de esta etapa.'
}];
export function Faq() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-14 md:py-16 bg-white" data-id="element-59">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-3xl" data-id="element-60">
        <div className="text-center mb-16" data-id="element-61">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-brand-navy" data-id="element-62">
            Preguntas Frecuentes
          </h2>
        </div>

        <div className="space-y-4" data-id="element-63">
          {faqs.map((faq, index) => <div key={index} className="border border-gray-200 rounded-2xl overflow-hidden bg-brand-cream/30" data-id="element-64">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-6 py-5 flex items-center justify-between text-left focus:outline-none" aria-expanded={openIndex === index} data-id="element-65">
                <span className="font-semibold text-brand-navy text-lg pr-8" data-id="element-66">
                  {faq.q}
                </span>
                <ChevronDown className={`w-5 h-5 text-brand-gold transition-transform duration-300 shrink-0 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-67" />
              </button>

              <AnimatePresence data-id="element-68">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3,
              ease: 'easeInOut'
            }} data-id="element-69">
                    <div className="px-6 pb-5 text-gray-600 leading-relaxed" data-id="element-70">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </section>;
}